import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Lottie from 'lottie-web';
import { SessionService } from '../../../../core/services/session.service';
import { Brand } from '../../../../shared/models/brand';
import { DistributionChannel } from '../../../../shared/models/distributionChannelType';
import { BlockedScreenLabels } from '../../../../shared/models/SurveyModel';
import { HelperService } from '../../../../shared/services/helper.service';
import { AgTranslateService } from '@ag/vc.ag-core/translate';

@Component({
  selector: 'app-blocked',
  templateUrl: './blocked.component.html',
  styleUrls: ['./blocked.component.scss', '../../../../shared/components/cta-container/cta-container.component.scss']
})
export class BlockedComponent implements OnInit, AfterViewInit {

  screenLabels = new BlockedScreenLabels();
  asset = './assets/unauthorized-user-blocked.json';
  callbackUrlFr: string;
  callbackUrlNl: string;
  isIncorrectPartner: boolean;
  partnerName: string;
  constructor(
    private readonly session: SessionService,
    private readonly helperService: HelperService,
    private readonly agTranslateService: AgTranslateService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.session.setHelpWidgetSubject(false);
    this.session.isUserBlocked = true;
    setTimeout(() => {
      this.session.setContext(Brand.AG, '');
    });
    this.route.queryParams.subscribe(params => {
      if ((params.callback_FR || params.callback_NL) && params.invalid){
        this.callbackUrlFr = this.returnWithHttp(params.callback_FR as string);
        this.callbackUrlNl = this.returnWithHttp(params.callback_NL as string);
        this.partnerName = (params?.partner as string)?.toString().toLowerCase().charAt(0).toUpperCase() + (params?.partner as string)?.toString().toLowerCase().substring(1);
        this.isIncorrectPartner = (params.invalid as string) ? (JSON.parse(params.invalid as string) as boolean) : false;
      }
      this.defineLabels();
    });
  }

  ngAfterViewInit(): void {
    const svgContainer = document.getElementById('jsonImageIcon');
    Lottie.loadAnimation(this.helperService.getLottieConfig(svgContainer, false, true, 'no-product', this.asset));
  }

  defineLabels(): void{
    if (!this.isIncorrectPartner){
      this.screenLabels.IntroText = 'Context.Blocked.IntroText';
      // if (context && Number(context) === DistributionChannel.AG) {
      //   this.screenLabels.title = 'Context.Blocked.Title_Uppie';
      //   this.screenLabels.desc = 'Context.Blocked.Blocked_Description_NoContext';
      //   this.screenLabels.CtaText = 'Context.Blocked.BlockedCTA_NoContext';
      // } else {
      //   this.screenLabels.title = 'Context.Blocked.Title';
      //   this.screenLabels.desc = 'Context.Blocked.Blocked_Description_Broker';
      //   this.screenLabels.CtaText = 'Context.Blocked.BlockedCTA_Broker';
      // }
      this.screenLabels.title = 'Context.Blocked.Title_Uppie';
      this.screenLabels.desc = 'Context.Blocked.Blocked_Description_NoContext';
      this.screenLabels.CtaText = 'Context.Blocked.BlockedCTA_NoContext';
    }else{
      this.screenLabels.IntroText = 'Context.Blocked.IntroText_IP';
      this.screenLabels.title = 'Context.Blocked.Title_IP';
      this.screenLabels.desc = 'Context.Blocked.Blocked_Description_IP';
      this.screenLabels.CtaText = 'Context.Blocked.BlockedCTA_IP';
      this.screenLabels.CtaTextSecondary = 'Context.Blocked.BlockedCTA_Back_IP'
    }
    
  }

  nextAction(event: string): void | boolean {
    if (event === 'forward') {
      if (this.callbackUrlFr || this.callbackUrlNl){
        if (this.agTranslateService.currentLang === 'nl'){
          window.location.href = this.callbackUrlNl;
        }else{
          window.location.href = this.callbackUrlFr;
        }
        
        return false;
      }
      const context = sessionStorage.getItem('blockedContext');
      if (context && Number(context) === Number(DistributionChannel.AG)) {
        window.location.href = AgAppConfigService.get<string>('publicsiteurl') + this.agTranslateService.currentLang;
      }
      else {
        window.location.href = 'https://www.aginsurance.be/' + this.agTranslateService.currentLang;
      }


    }else{
      if (this.isIncorrectPartner){
        if (this.agTranslateService.currentLang === 'nl'){
          window.location.href = "https://www.uppie.be/nl/waar-te-vinden?utm_medium=referral&utm_source=uppie&utm_campaign=m2_blockingscreen_id-nl&utm_content=choosepartner";
        }
        else{
          window.location.href= "https://www.uppie.be/fr/ou-trouver-uppie?utm_medium=referral&utm_source=uppie&utm_campaign=m2_blockingscreen_id-fr&utm_content=choosepartner";
        }
      }
    }
  }

  returnWithHttp(url: string): string{
    if (!url.startsWith('http')){
      return `https://${url}`;
    }else{
      return url;
    }
  }
}
